export default __webpack_public_path__ + "3a93e9d8caf77bc3d503bf522860f04d.jpg";